module.exports = __webpack_public_path__ + "media/images/social/telegram-plane-brands-e50bf291d2ee3e937b4093a128a93064.svg";